module.exports = __webpack_public_path__ + "img/logo-default.2ae5cf40.png";